/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDetailComponentControllerResponseDto } from './AssetDetailComponentControllerResponseDto';
import {
    AssetDetailComponentControllerResponseDtoFromJSON,
    AssetDetailComponentControllerResponseDtoFromJSONTyped,
    AssetDetailComponentControllerResponseDtoToJSON,
    AssetDetailComponentControllerResponseDtoToJSONTyped,
} from './AssetDetailComponentControllerResponseDto';
import type { AssetDetailLookupResponseDto } from './AssetDetailLookupResponseDto';
import {
    AssetDetailLookupResponseDtoFromJSON,
    AssetDetailLookupResponseDtoFromJSONTyped,
    AssetDetailLookupResponseDtoToJSON,
    AssetDetailLookupResponseDtoToJSONTyped,
} from './AssetDetailLookupResponseDto';

/**
 * 
 * @export
 * @interface AssetDetailComponentResponseDto
 */
export interface AssetDetailComponentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    serialNumber: string | null;
    /**
     * Discriminator: connector | controller
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    componentType: string | null;
    /**
     * OCPP connector index (1, 2, 3, …)
     * @type {number}
     * @memberof AssetDetailComponentResponseDto
     */
    connectorId: number | null;
    /**
     * OCPP charge-box / controller identity
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    ocppId: string | null;
    /**
     * FK to the controller ComponentSchema
     * @type {string}
     * @memberof AssetDetailComponentResponseDto
     */
    controllerId: string | null;
    /**
     * 
     * @type {AssetDetailComponentControllerResponseDto}
     * @memberof AssetDetailComponentResponseDto
     */
    controller: AssetDetailComponentControllerResponseDto | null;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof AssetDetailComponentResponseDto
     */
    componentClass: AssetDetailLookupResponseDto | null;
    /**
     * 
     * @type {AssetDetailLookupResponseDto}
     * @memberof AssetDetailComponentResponseDto
     */
    parentComponent: AssetDetailLookupResponseDto | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailComponentResponseDto
     */
    installedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailComponentResponseDto
     */
    removedAt: Date | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetDetailComponentResponseDto
     */
    attributes: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailComponentResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetDetailComponentResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetDetailComponentResponseDto interface.
 */
export function instanceOfAssetDetailComponentResponseDto(value: object): value is AssetDetailComponentResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('componentType' in value) || value['componentType'] === undefined) return false;
    if (!('connectorId' in value) || value['connectorId'] === undefined) return false;
    if (!('ocppId' in value) || value['ocppId'] === undefined) return false;
    if (!('controllerId' in value) || value['controllerId'] === undefined) return false;
    if (!('controller' in value) || value['controller'] === undefined) return false;
    if (!('componentClass' in value) || value['componentClass'] === undefined) return false;
    if (!('parentComponent' in value) || value['parentComponent'] === undefined) return false;
    if (!('installedAt' in value) || value['installedAt'] === undefined) return false;
    if (!('removedAt' in value) || value['removedAt'] === undefined) return false;
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetDetailComponentResponseDtoFromJSON(json: any): AssetDetailComponentResponseDto {
    return AssetDetailComponentResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailComponentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailComponentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'serialNumber': json['serialNumber'],
        'componentType': json['componentType'],
        'connectorId': json['connectorId'],
        'ocppId': json['ocppId'],
        'controllerId': json['controllerId'],
        'controller': AssetDetailComponentControllerResponseDtoFromJSON(json['controller']),
        'componentClass': AssetDetailLookupResponseDtoFromJSON(json['componentClass']),
        'parentComponent': AssetDetailLookupResponseDtoFromJSON(json['parentComponent']),
        'installedAt': (json['installedAt'] == null ? null : new Date(json['installedAt'])),
        'removedAt': (json['removedAt'] == null ? null : new Date(json['removedAt'])),
        'attributes': json['attributes'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetDetailComponentResponseDtoToJSON(json: any): AssetDetailComponentResponseDto {
    return AssetDetailComponentResponseDtoToJSONTyped(json, false);
}

export function AssetDetailComponentResponseDtoToJSONTyped(value?: AssetDetailComponentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'serialNumber': value['serialNumber'],
        'componentType': value['componentType'],
        'connectorId': value['connectorId'],
        'ocppId': value['ocppId'],
        'controllerId': value['controllerId'],
        'controller': AssetDetailComponentControllerResponseDtoToJSON(value['controller']),
        'componentClass': AssetDetailLookupResponseDtoToJSON(value['componentClass']),
        'parentComponent': AssetDetailLookupResponseDtoToJSON(value['parentComponent']),
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
        'attributes': value['attributes'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

